/* global System */
// register component(s) with react habitat

export default {
  calculator_roi_v2: () => System.import('./index'),
}
